import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@components/@core/Avatar';
import Button from '@components/@core/Button';

const ConnectionCard = ({ data, tab, onOpen, onClick, onReject }) => {
    const { avatar, connector, status } = data;
    const { type, content, user } = connector;
    let btnText = 'MESSAGE';
    if (tab === 'received' || tab === 'recommended') {
        btnText = 'CONNECT';
    } else if (tab === 'sent') {
        btnText = 'DISMISS';
    } else if (tab === 'companies') {
        btnText = 'UNFOLLOW';
    }

    if (type === 'content') {
        return (
            <div className="connection-card">
                <div className={`card-status ${status === 'active' ? 'online' : ''}`} />
                <Avatar className="mb-3" size="small" url={connector?.avatar} name={content?.name} onToggle={onOpen} />
                <p className="dsl-b16 bold text-center truncate-two mb-2">{content?.name}</p>
                <p className="dsl-b14 text-400 truncate-two text-center">{connector?.slug}</p>
                <p className="dsl-m12 text-400">{`Followed by: ${content?.stats?.product_count}`}</p>
                {tab === 'sent' && <p className="dsl-m12 text-400">Connection request sent...</p>}
                <Button type="medium" name={btnText} onClick={onClick} />
                {tab === 'received' && <Button type="link" name="REJECT" onClick={onReject} />}
            </div>
        );
    }

    const name = `${user?.first_name} ${user?.last_name}`;
    return (
        <div className={`connection-card ${tab === 'recommended' ? 'light-blue' : ''}`}>
            {tab !== 'recommended' && <div className={`card-status ${status === 'active' ? 'online' : ''}`} />}
            <Avatar className="mb-3" url={avatar} name={name} size="small" onToggle={onOpen} />
            <p className="dsl-b16 bold truncate-two text-center mb-2">{name}</p>
            <p className="dsl-b14 text-400 truncate-two text-center">{user?.profile?.job_title}</p>
            <p className="dsl-m12 text-400">{user?.stats ? `${user?.stats.connections} mutual connections` : 'Based on your profile'}</p>
            {tab === 'sent' && <p className="dsl-m12 text-400">Connection request sent...</p>}
            <Button type="medium" name={btnText} onClick={onClick} />
            {tab === 'received' && <Button type="link" name="REJECT" onClick={onReject} />}
        </div>
    );
};

ConnectionCard.propTypes = {
    data: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
    }),
    tab: PropTypes.string,
    onClick: PropTypes.func,
    onOpen: PropTypes.func,
    onReject: PropTypes.func,
};

ConnectionCard.defaultProps = {
    data: {
        id: 0,
        name: '',
    },
    tab: '',
    onClick: () => {},
    onOpen: () => {},
    onReject: () => {},
};

export default ConnectionCard;
